import MuiAlert from '@material-ui/lab/Alert';
import {withStyles} from '@material-ui/core';

export const Alert = withStyles(theme => ({
    message: {
        '& a': {
            color: theme.palette.common.white,
            textDecoration: 'underline',
            '&:hover, &:active, &:focus, &:visited': {
                color: theme.palette.text.secondary,
                textDecoration: 'none'
            }
        }
    }
}))(MuiAlert);
